import React, { useState } from "react";
import styles from "../../assets/styles/loan.module.css";
import Strings from "../../utils/stringUtil";
import { Box, Button, Typography } from "@mui/material";
import { loanOfferings } from "../../utils/businessLoanUtil";
import AppIcons from "../../utils/appIcons";
import Routes from "../../utils/routesUtil";
import { isMobile } from "../../utils/responsiveUtil";

const defaultHoverItem = 1;

function Offerings() {
  const [hoveredItemIndex, setHoveredItemIndex] = useState(defaultHoverItem);
  return (
    <Box
      style={{ transform: isMobile ? "scale(1)" : "scale(0.88)" }}
      className={`container`}
      position={"relative"}
    >
      <Box pt={isMobile ? "80px" : "40px"}>
        <Box className={styles.flexColumnCenter}>
          <Typography className={styles.loanTitle}>
            {Strings.businessLoanOfferingsTitle}
          </Typography>
          <Typography
            className={`${styles.loanDescription} ${styles.offerSubTitle}`}
          >
            {Strings.businessLoanOfferingsSubTitle}
          </Typography>
        </Box>
      </Box>
      {!isMobile && renderVectors()}
      <Box mt={isMobile ? "40px" : "60px"} className={styles.offersContainer}>
        {loanOfferings.map((offer, index) => {
          return (
            <OfferCard
              offer={offer}
              key={index}
              offerIndex={index}
              setHoveredItemIndex={setHoveredItemIndex}
              hoveredItemIndex={hoveredItemIndex}
            />
          );
        })}
      </Box>
    </Box>
  );
}

function renderVectors() {
  return (
    <>
      <img
        src={AppIcons.imgStars}
        width={40}
        className={styles.offerStarVector}
      />
      <img
        src={AppIcons.imgBlueStar}
        width={40}
        className={styles.offerBlueStarVector}
      />
      <img
        src={AppIcons.icGreyCircle}
        width={50}
        className={styles.offerGreyCircle}
      />
    </>
  );
}
function GreenTick() {
  return (
    <img
      src={AppIcons.icGreenTick}
      width={"17px"}
      style={{ marginTop: "3px" }}
    />
  );
}

const OfferCard = function ({
  offer,
  offerIndex,
  hoveredItemIndex,
  setHoveredItemIndex,
}) {
  const isActiveSlide = isMobile ? false : hoveredItemIndex === offerIndex;
  return (
    <Box
      onMouseEnter={() => setHoveredItemIndex(offerIndex)}
      onMouseLeave={() => setHoveredItemIndex(defaultHoverItem)}
      className={` ${
        isActiveSlide ? styles.activeOfferCard : styles.offerCard
      }`}
      style={{ backgroundColor: "white" }}
    >
      <Box
        className={`${
          isActiveSlide
            ? styles.activeOfferCardTopVector
            : styles.offerCardTopVector
        }`}
      >
        <Box className={styles.flexColumnCenter}>
          <img src={offer.icon} alt={offer.title} width={isMobile ? 70 : 100} />
          <Typography className={styles.offerAmount}>
            {offer.loanAmount}
          </Typography>
        </Box>
      </Box>
      <Box px={"29px"} pb={"27px"} pt="4px">
        <Typography
          fontWeight={isActiveSlide ? 600 : 500}
          className={styles.offerTitle}
          dangerouslySetInnerHTML={{ __html: offer.title }}
        />

        <Typography
          pt="16px"
          className={styles.offerDetails}
          fontWeight={isActiveSlide ? 400 : 300}
        >
          <GreenTick /> Tenure: {offer.tenure}
        </Typography>
        <div className={styles.horizontalLine} />
        <Typography
          className={styles.offerDetails}
          fontWeight={isActiveSlide ? 400 : 300}
        >
          <GreenTick /> Ideal For: {offer.idealFor}
        </Typography>
        <div className={styles.horizontalLine} />
        <Typography
          className={styles.offerDetails}
          fontWeight={isActiveSlide ? 400 : 300}
        >
          <GreenTick /> Interest rate: {offer.interestRate}
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"center"}
        pb={"20px"}
        px={isMobile ? 7 : 2}
      >
        <Button
          variant="outlined"
          onClick={() => window.open(Routes.MM_PLAY_STORE_URL, "_blank")}
          className={
            isActiveSlide ? styles.activeApplyNowBtn : styles.applyNowBtn
          }
        >
          Apply Now
        </Button>
      </Box>
    </Box>
  );
};

export default Offerings;
